const presaleElement = document.getElementById('presale-wrapper');
const presaleVariantIds = presaleElement.dataset.showfor.split(',');
const presaleButton = document.getElementById('notify-reveal');
const saleButton = document.querySelector('.product-buy-buttons--primary');
const inputRootLabels = document.querySelectorAll('product-options-root input + label');

document.querySelector('product-options-root').addEventListener('click', changeButton)
document.addEventListener('DOMContentLoaded', changeButton)

function changeButton() {
  setTimeout(()=>{
    const varId = getURLVariant();
    console.log(presaleVariantIds);
    console.log(varId.toString());
    console.log(presaleVariantIds.includes(varId.toString()));
    if (presaleVariantIds.includes(varId.toString())) {
      setVisibility(presaleElement, true);
      setVisibility(saleButton, false);
    } else {  
      setVisibility(presaleElement, false);
      setVisibility(saleButton, true);
    }
    
  },0)
}

function getURLVariant() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get('variant') || +custom_first_available_variant_id;
}

function setVisibility(element, bool) {
  if (bool) {
    console.log('HIDE');
    element.classList.remove('hide');
  } else {
    console.log('SHOW');
    element.classList.add('hide');
  }
} 